module.exports = __webpack_public_path__ + "static/img/pdd2.c59f53b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdd2.png
// module id = WC0h
// module chunks = 1